var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('span',{staticClass:"modal-body-text"},[_vm._v("You are about to "+_vm._s(_vm.status)+" "+_vm._s(_vm.name)+".")]),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"modal-body-text"},[_vm._v("Are you sure you want to continue?")]),_vm._v(" "),_c('br')])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55beae91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/BlockUser.vue
// module id = 1668
// module chunks = 181